import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatImage } from '../../../../base/publicMethod/index';
import classNames from '../utils/classNames';
import { getImageUrl, imageAttr } from '../utils/image';
import formatTime from '../utils/formatTime';
import styles from '../styles/styles.css';
import imageUrl from './imageUrl';
import { handleCallNewsApp, h5PageCount } from '../../../../utils';
import Observer from '@researchgate/react-intersection-observer';

/* 三图模式 */
class ThreeImage extends PureComponent {
    static propTypes = {
        item: PropTypes.object,
        url: PropTypes.string,
        // pinglunUrl: PropTypes.string,
        countMapCache: PropTypes.object,
        isDisplaySource: PropTypes.bool,
        isCount: PropTypes.bool,
        isNewsTime: PropTypes.bool,
        isLazyImage: PropTypes.bool,
        isFormatTime: PropTypes.bool,
        isDisplaySlideTujiText: PropTypes.bool,
        searchPathMap: PropTypes.object,
        getExposureData: PropTypes.func,
    };

    static defaultProps = {
        isDisplaySource: true,
        isCount: true,
        isNewsTime: true,
        isFormatTime: true,
        isDisplaySlideTujiText: false,
        searchPathMap: {},
    };

    handleClick = (url, id, newstype, kind, clickCountConfig, downloads = {}) => {
        const nodata = '';
        const doc_type = newstype;
        const aid = id;
        const to_url = url;

        this.feedClickCountFn(clickCountConfig);

        handleCallNewsApp(nodata, doc_type, aid, to_url, 0, 0, kind, {}, downloads);
    };

    feedClickCountFn = config => {
        if (config) {
            h5PageCount([config]);
        }
    };

    tujiView(noTextRender = null) {
        const { isDisplaySlideTujiText } = this.props;

        return isDisplaySlideTujiText ? <div className={styles.page}>图集</div> : noTextRender;
    }

    observerHandle = (event, unobserve) => {
        const { item } = this.props;
        const expCountConfig = item && item.expCountConfig;

        if (event.isIntersecting && expCountConfig) {
            unobserve();
            this.props.getExposureData([expCountConfig]);
        }
    };

    render() {
        const { isDisplaySource, isCount, isNewsTime, isFormatTime, isLazyImage, searchPathMap } = this.props;
        const { url, item, countMapCache } = this.props;
        const {
            title,
            thumbnails,
            source,
            commentUrl,
            guid,
            id,
            newsTime,
            page,
            callUp,
            linkMark,
            heatMark,
            newstype,
            clickCount,
            kind,
            tagColor,
            downloads,
        } = item;
        const image = thumbnails.image;
        const isSource = isDisplaySource && source && source !== '';
        const width = imageAttr(230);
        const height = imageAttr(152);
        const style = { backgroundImage: `url('${imageUrl.normal}')` };
        const src0 = formatImage(getImageUrl(image[0]), 230, 152);
        const src1 = formatImage(getImageUrl(image[1]), 230, 152);
        const src2 = formatImage(getImageUrl(image[2]), 230, 152);
        const props0 = { width, height, alt: title };
        const props1 = { width, height, alt: title };
        const props2 = { width, height, alt: title };
        const clickCountConfig = clickCount ? clickCount : '';

        if (isLazyImage) {
            props0.src = imageUrl.normal;
            props0['data-lazy-src'] = src0;
            props1.src = imageUrl.normal;
            props1['data-lazy-src'] = src1;
            props2.src = imageUrl.normal;
            props2['data-lazy-src'] = src2;
        } else {
            props0.src = src0;
            props1.src = src1;
            props2.src = src2;
        }
        let tagColorStyle = {};

        if (tagColor) {
            switch (tagColor) {
                case 7:
                    tagColorStyle = { color: '#3091f5' };
                    break;
                case 8:
                    tagColorStyle = { color: '#ff884c' };
                    break;
                case 9:
                    tagColorStyle = { color: '#4bc259' };
                    break;
                case 10:
                    tagColorStyle = { color: '#f54343' };
                    break;
            }
        }

        return (
            <Observer onChange={this.observerHandle}>
                <div className={styles.listItem} data-list-item>
                    <h4 className={styles.title}>
                        {callUp ? (
                            <a
                                onClick={this.handleClick.bind(
                                    this,
                                    url,
                                    id,
                                    newstype,
                                    kind,
                                    clickCountConfig,
                                    downloads,
                                )}>
                                {title}
                            </a>
                        ) : (
                            <a onClick={this.feedClickCountFn.bind(this, clickCountConfig)} href={url}>
                                {title}
                            </a>
                        )}
                    </h4>
                    <div className={classNames(styles.mb14, styles.flex)}>
                        {callUp ? (
                            <Fragment>
                                <a
                                    className={classNames(styles.mr4, styles.image, styles.noshrink)}
                                    style={style}
                                    onClick={this.handleClick.bind(
                                        this,
                                        url,
                                        id,
                                        newstype,
                                        kind,
                                        clickCountConfig,
                                        downloads,
                                    )}>
                                    <img {...props0} />
                                </a>
                                <a
                                    className={classNames(styles.mr4, styles.image, styles.noshrink)}
                                    style={style}
                                    onClick={this.handleClick.bind(
                                        this,
                                        url,
                                        id,
                                        newstype,
                                        kind,
                                        clickCountConfig,
                                        downloads,
                                    )}>
                                    <img {...props1} />
                                </a>
                                <a
                                    className={classNames(styles.image, styles.hasPage, styles.noshrink)}
                                    style={style}
                                    onClick={this.handleClick.bind(
                                        this,
                                        url,
                                        id,
                                        newstype,
                                        kind,
                                        clickCountConfig,
                                        downloads,
                                    )}>
                                    <img {...props2} />
                                    {page ? <div className={styles.page}>{this.tujiView(`${page}图`)}</div> : null}
                                    {this.tujiView()}
                                </a>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <a
                                    onClick={this.feedClickCountFn.bind(this, clickCountConfig)}
                                    className={classNames(styles.mr4, styles.image, styles.noshrink)}
                                    style={style}
                                    href={url}>
                                    <img {...props0} />
                                </a>
                                <a
                                    onClick={this.feedClickCountFn.bind(this, clickCountConfig)}
                                    className={classNames(styles.mr4, styles.image, styles.noshrink)}
                                    style={style}
                                    href={url}>
                                    <img {...props1} />
                                </a>
                                <a
                                    onClick={this.feedClickCountFn.bind(this, clickCountConfig)}
                                    className={classNames(styles.image, styles.hasPage, styles.noshrink)}
                                    style={style}
                                    href={url}>
                                    <img {...props2} />
                                    {page ? <div className={styles.page}>{this.tujiView(`${page}图`)}</div> : null}
                                    {this.tujiView()}
                                </a>
                            </Fragment>
                        )}
                    </div>
                    <p className={styles.p}>
                        {// 显示频道
                        item.searchPath && searchPathMap[item.searchPath] ? (
                            <span className={classNames(styles.mr16, styles.searchPath)}>
                                {searchPathMap[item.searchPath]}
                            </span>
                        ) : null}
                        {callUp === 1 && (
                            <span
                                onClick={this.handleClick.bind(
                                    this,
                                    url,
                                    id,
                                    newstype,
                                    kind,
                                    clickCountConfig,
                                    downloads,
                                )}
                                className={styles.openApp}>
                                打开APP阅读
                            </span>
                        )}
                        {linkMark && (
                            <a href={url} onClick={this.feedClickCountFn.bind(this, clickCountConfig)}>
                                <span className={styles.mr16}>网页阅读</span>
                            </a>
                        )}
                        {heatMark && (
                            <span style={tagColorStyle} className={styles.openApp}>
                                {heatMark}
                            </span>
                        )}
                        {isSource ? <span className={styles.mr16}>{source}</span> : null}
                        {isCount && (commentUrl || guid) && countMapCache[id] ? (
                            <span className={styles.mr16}>{countMapCache[id]}评</span>
                        ) : null}
                        {isNewsTime && newsTime ? <time>{isFormatTime ? formatTime(newsTime) : newsTime}</time> : null}
                    </p>
                </div>
            </Observer>
        );
    }
}

export default ThreeImage;
